// extracted by mini-css-extract-plugin
export default {"your_rd":"ws","title":"xs","subtitle":"ys","rd_bio_wrapper":"zs","rd_text_mobile":"As","rd_bio":"Bs","img":"Cs","rd_info":"Es","rd_name":"Fs","rd_stat":"Gs","rd_text":"Hs","btn_mobile":"Is"};
    if(module.hot) {
      // 1713361643825
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  